var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFpay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79,
    height: 45,
    viewBox: "0 0 79 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1383",
    "data-name": "Grupo 1383",
    transform: "translate(-233 -545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1380",
    "data-name": "Grupo 1380",
    transform: "translate(233 545)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_568",
    "data-name": "Rect\\xE1ngulo 568",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 78,
    height: 44,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Fpay",
    transform: "translate(234.001 552.831)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_7",
    "data-name": "Capa 7",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5267",
    "data-name": "Trazado 5267",
    d: "M239.124-269.814c-.08-.156-.285-.186-.622-.186H228.366a7.261,7.261,0,0,0-3.039.527,5.392,5.392,0,0,0-1.969,1.427,5.24,5.24,0,0,0-1.051,2.079,9.563,9.563,0,0,0-.307,2.432v18a.7.7,0,0,0,.213.6,1.1,1.1,0,0,0,.615.148h1.15a2.464,2.464,0,0,0,2.387-2.789v-8.265h10.815c.326,0,.512-.064.6-.22a1.184,1.184,0,0,0,.125-.6V-258.7a1.121,1.121,0,0,0-.125-.656.772.772,0,0,0-.6-.171H226.363v-4.227a2.464,2.464,0,0,1,.581-1.768,2.541,2.541,0,0,1,1.92-.6h9.627c.323,0,.524-.049.615-.182a1.115,1.115,0,0,0,.156-.649v-2.2a1.033,1.033,0,0,0-.144-.619",
    transform: "translate(-221.999 270)",
    fill: "#48a018"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_6",
    "data-name": "Capa 6",
    transform: "translate(19.685 9.13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5268",
    "data-name": "Trazado 5268",
    d: "M744.2-8.188c0,.44-.118.5-.554.5H741.35c-.376,0-.55-.091-.55-.5v-19.39a.651.651,0,0,1,.463-.7,15.537,15.537,0,0,1,6.125-1.119c5.047,0,7.05,3.525,7.05,8.022,0,4.379-2.2,8.022-6.789,8.022a13.915,13.915,0,0,1-3.453-.414Zm2.732-18.229A10.379,10.379,0,0,0,744.2-26v9.342a10.689,10.689,0,0,0,2.876.414c2.3,0,3.939-1.294,3.939-5.115,0-3.73-1.556-5.054-4.083-5.054",
    transform: "translate(-740.8 29.4)",
    fill: "#55585a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_5",
    "data-name": "Capa 5",
    transform: "translate(35.828 9.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5269",
    "data-name": "Trazado 5269",
    d: "M1178.6-15.224a15.031,15.031,0,0,1-5.912,1.028c-5.1,0-6.489-2.231-6.489-4.906s1.708-5.259,6.31-5.259h3.248v-.5c0-1.5-.493-2.584-2.986-2.584a15.942,15.942,0,0,0-4.026.588c-.406.118-.581.057-.668-.292l-.4-1.681c-.087-.323-.027-.5.262-.619a16.215,16.215,0,0,1,5.388-.85c4,0,5.825,1.878,5.825,5.29V-16.2a.949.949,0,0,1-.55.971m-2.842-6.515h-2.823c-1.29,0-3.347.175-3.347,2.52,0,1.677,1.233,2.265,3.112,2.265a10.289,10.289,0,0,0,3.058-.474Z",
    transform: "translate(-1166.2 30.3)",
    fill: "#55585a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4",
    transform: "translate(50.368 9.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5270",
    "data-name": "Trazado 5270",
    d: "M1558.274-1.548c-.911,2.709-2.444,3.711-4.914,3.711a9.211,9.211,0,0,1-2.592-.357c-.41-.087-.5-.2-.41-.558l.41-1.795c.091-.383.235-.383.588-.323a5.805,5.805,0,0,0,1.446.2,2.325,2.325,0,0,0,2.588-1.856l.618-1.852h-.706c-.706,0-1.119-.087-1.472-1.207l-4.413-13.509c-.091-.292.057-.414.323-.414h2.77c.41,0,.527.087.615.379l1.992,6.735,1.522,5.3h.148l1.643-5.358,2.167-6.644c.087-.288.175-.41.584-.41h2.66c.262,0,.379.148.288.379l-5.855,17.508Z",
    transform: "translate(-1549.391 19.5)",
    fill: "#55585a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_3",
    "data-name": "Capa 3",
    transform: "translate(64.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5271",
    "data-name": "Trazado 5271",
    d: "M1926.354-270H1921a6.81,6.81,0,0,1,6.807,6.811v7.354a.873.873,0,0,0,.869.869h4.258a.212.212,0,0,0,.209-.212v-8a6.823,6.823,0,0,0-6.819-6.826h.03",
    transform: "translate(-1921 270)",
    fill: "#005fc5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2",
    transform: "translate(61.581)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5272",
    "data-name": "Trazado 5272",
    d: "M1847.806-270h-2.349a.557.557,0,0,0-.4.165.557.557,0,0,0-.162.4v3.305a1.469,1.469,0,0,0,1.469,1.469h6.728a1.5,1.5,0,0,1,1.5,1.491v-.015a6.8,6.8,0,0,0-6.8-6.8",
    transform: "translate(-1844.9 270)",
    fill: "#002984"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFpay);
export default __webpack_public_path__ + "static/media/fpay.ada477273f925aec21db2101049f72fd.svg";
export { ForwardRef as ReactComponent };